module.exports = __webpack_public_path__ + "images/visa-9deb00.svg";